import React from 'react';
import autoCashbackHi from '../../assets/auto_cashback_images/AutoCashback_hi.png'

const Hindi = () => {
  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
        <img style={{width: '100%', objectFit: 'contain'}} src={autoCashbackHi} />
    </div>
  )
}

export default Hindi